import styled from "styled-components"

export const Separator = styled.div.attrs<{ $vertical?: boolean; $spaced?: boolean }>((props) => ({
  $vertical: props.$vertical ?? false,
  $spaced: props.$spaced ?? false,
}))`
  ${({ theme, $vertical }) => {
    if ($vertical) {
      return `
        ${theme.separator.left};
        height: 100%;
      `
    }
    return `
        ${theme.separator.bottom};
        width: 100%;
      `
  }}

  margin: ${({ $spaced }) => ($spaced ? "0.5rem" : "0")};
`
